import type {FC} from 'react'
import {useQuery, useMutation} from 'react-query'
import {toast} from 'react-toastify'
import {ModalDefault} from '../../ui'
import {getMemberById, getListMemberCycleByMemberId} from '../../../modules/services/member.service'
import {pushNotification} from '../../../modules/services/self-care.service'

interface Props {
  id: number
}

const ModalProgressState: FC<Props> = ({id}) => {
  const {data} = useQuery(['member', id], 
    () => getMemberById(id),
    {
      enabled : id !== 0 ? true : false
    }
  )
  const {data: memberCycle} = useQuery(['getListMemberCycleByMemberId', id], () =>
    getListMemberCycleByMemberId(id.toString())
  )
  const ongoingMemberCycle = (memberCycle?.data as Array<any>)?.find(
    (mc) => mc.attributes.cycle.data.id === data?.attributes?.ongoing_cycle?.data.id
  )
  const diff =
    new Date().getTime() - (new Date(ongoingMemberCycle?.attributes?.startedAt).getTime() || 0)

  const pushNotificationMutation = useMutation(pushNotification, {
    onSuccess: async () => {
      toast.success('Push Notification Success')
    },
    onError(error: any, variables, context) {
      console.log('Error', error.response?.data)
      toast.error(error.response?.data?.error?.message)
    },
  })

  const handlePushNotification = () => {
    pushNotificationMutation.mutate({memberId: id})
  }
    const historyPushData = data?.attributes?.self_care_activity_histories?.data.sort((a:any , b:any) => b.id - a.id) || []
    const startAt = data?.attributes?.cycles?.data.find((e:any) => e.attributes?.cycle?.data?.attributes?.name === data?.attributes?.ongoing_cycle.data?.attributes?.name ) ?? {}
    const time =  new Date().getTime() - new Date(startAt?.attributes?.startedAt).getTime()
    const memberTerms =  Math.ceil(time / (1000 * 60 * 60 * 24)) 

  return (
    <ModalDefault id='progress-state' title='Progress State' hides={['footer']}>
      <div className='col py-2'>
        <div className='d-flex gap-2'>
          <h4 className='fs-6 fw-bold'>Name:</h4>
          <p className='fs-6 ms-8'>{data?.attributes.fullname}</p>
        </div>
        <div className='d-flex gap-2'>
          <h4 className='fs-6 fw-bold'>Cycle:</h4>
          <p className='fs-6 ms-8'>
            {data?.attributes.ongoing_cycle.data?.attributes.cycle} -{' '}
            {data?.attributes.ongoing_cycle.data?.attributes.name}
          </p>
        </div>
        <div className='d-flex gap-2'>
          <h4 className='fs-6 fw-bold'>WA Notification:</h4>
          <p className='fs-6 ms-8'>{data?.attributes?.isReminderActivated ? "Active" : "Non-Active" }</p>
        </div>
        <div className='d-flex gap-2'>
          <h4 className='fs-6 fw-bold'>Member Terms:</h4>
          <p className='fs-6 ms-8'>{startAt.attributes?.completedAt ? "-" : memberTerms} Day(s)</p>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='d-flex gap-2'>
            <h4 className='fs-6 fw-bold'>Push Notification Msg:</h4>
            <p className='fs-6 ms-8'>{data?.attributes?.self_care_activity_histories?.data.length || 0} Times</p>
          </div>
          <button onClick={handlePushNotification} type='button' className='btn btn-sm btn-info'>
            Push Confirmation
          </button>
        </div>
        <div className='py-2'>
          <hr />
        </div>
        <h3 className='fw-bold fs-12 mb-4'>History Push Confirmation</h3>
        {
          historyPushData.map((e: any, i: any) => (
          <div className='d-flex gap-6' key={i}>
              <div
                className='d-flex justify-content-center align-items-center border border-2 border-primary'
                style={{
                  width: '32px',
                  height: '32px',
                  borderTopLeftRadius: '16px',
                  borderTopRightRadius: '16px',
                  borderBottomLeftRadius: '16px',
                }}
              >
                {i+1}
              </div>
              <div className='col'>
                <p className='fs-6'>{e.attributes.push_date}</p>
                <p className='fs-6'>
                  <span className='fw-bold'>Cycle: </span> {e.attributes.cycle_name}
                </p>
              </div>
          </div>
        ))}
      </div>
    </ModalDefault>
  )
}

export default ModalProgressState
